'use client';
"use strict";

var _excluded = ["status", "addRole"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Alert: function Alert() {
    return _Alert;
  },
  AlertDescription: function AlertDescription() {
    return _AlertDescription;
  },
  AlertIcon: function AlertIcon() {
    return _AlertIcon;
  },
  AlertTitle: function AlertTitle() {
    return _AlertTitle;
  },
  useAlertStyles: function useAlertStyles() {
    return _useAlertStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/alert.tsx

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_system = require("@chakra-ui/system"); // src/alert-context.ts


var import_react_context = require("@chakra-ui/react-context"); // src/icons.tsx


var import_icon = require("@chakra-ui/icon");

var import_jsx_runtime = require("react/jsx-runtime");

function CheckIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("path", {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    })
  }));
}

function InfoIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("path", {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    })
  }));
}

function WarningIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("path", {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    })
  }));
} // src/alert-context.ts


var import_spinner = require("@chakra-ui/spinner");

var _ref = (0, import_react_context.createContext)({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}),
    _ref2 = _slicedToArray(_ref, 2),
    AlertProvider = _ref2[0],
    useAlertContext = _ref2[1];

var _ref3 = (0, import_react_context.createContext)({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}),
    _ref4 = _slicedToArray(_ref3, 2),
    AlertStylesProvider = _ref4[0],
    _useAlertStyles = _ref4[1];

var STATUSES = {
  info: {
    icon: InfoIcon,
    colorScheme: "blue"
  },
  warning: {
    icon: WarningIcon,
    colorScheme: "orange"
  },
  success: {
    icon: CheckIcon,
    colorScheme: "green"
  },
  error: {
    icon: WarningIcon,
    colorScheme: "red"
  },
  loading: {
    icon: import_spinner.Spinner,
    colorScheme: "blue"
  }
};

function getStatusColorScheme(status) {
  return STATUSES[status].colorScheme;
}

function getStatusIcon(status) {
  return STATUSES[status].icon;
} // src/alert.tsx


var import_jsx_runtime2 = require("react/jsx-runtime");

var _Alert = (0, import_system.forwardRef)(function Alert2(props, ref) {
  var _a;

  var _ref5 = (0, import_system.omitThemingProps)(props),
      _ref5$status = _ref5.status,
      status = _ref5$status === void 0 ? "info" : _ref5$status,
      _ref5$addRole = _ref5.addRole,
      addRole = _ref5$addRole === void 0 ? true : _ref5$addRole,
      rest = _objectWithoutProperties(_ref5, _excluded);

  var colorScheme = (_a = props.colorScheme) != null ? _a : getStatusColorScheme(status);
  var styles = (0, import_system.useMultiStyleConfig)("Alert", _objectSpread(_objectSpread({}, props), {}, {
    colorScheme: colorScheme
  }));

  var alertStyles = _objectSpread({
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden"
  }, styles.container);

  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(AlertProvider, {
    value: {
      status: status
    },
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(AlertStylesProvider, {
      value: styles,
      children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
        "data-status": status,
        role: addRole ? "alert" : void 0,
        ref: ref
      }, rest), {}, {
        className: (0, import_shared_utils.cx)("chakra-alert", props.className),
        __css: alertStyles
      }))
    })
  });
});

_Alert.displayName = "Alert"; // src/alert-description.tsx

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_system2 = require("@chakra-ui/system");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _AlertDescription = (0, import_system2.forwardRef)(function AlertDescription2(props, ref) {
  var styles = _useAlertStyles();

  var _useAlertContext = useAlertContext(),
      status = _useAlertContext.status;

  var descriptionStyles = _objectSpread({
    display: "inline"
  }, styles.description);

  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    "data-status": status
  }, props), {}, {
    className: (0, import_shared_utils2.cx)("chakra-alert__desc", props.className),
    __css: descriptionStyles
  }));
});

_AlertDescription.displayName = "AlertDescription"; // src/alert-icon.tsx

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_system3 = require("@chakra-ui/system");

var import_jsx_runtime4 = require("react/jsx-runtime");

function _AlertIcon(props) {
  var _useAlertContext2 = useAlertContext(),
      status = _useAlertContext2.status;

  var BaseIcon = getStatusIcon(status);

  var styles = _useAlertStyles();

  var css = status === "loading" ? styles.spinner : styles.icon;
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system3.chakra.span, _objectSpread(_objectSpread({
    display: "inherit",
    "data-status": status
  }, props), {}, {
    className: (0, import_shared_utils3.cx)("chakra-alert__icon", props.className),
    __css: css,
    children: props.children || /* @__PURE__ */(0, import_jsx_runtime4.jsx)(BaseIcon, {
      h: "100%",
      w: "100%"
    })
  }));
}

_AlertIcon.displayName = "AlertIcon"; // src/alert-title.tsx

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_system4 = require("@chakra-ui/system");

var import_jsx_runtime5 = require("react/jsx-runtime");

var _AlertTitle = (0, import_system4.forwardRef)(function AlertTitle2(props, ref) {
  var styles = _useAlertStyles();

  var _useAlertContext3 = useAlertContext(),
      status = _useAlertContext3.status;

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system4.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    "data-status": status
  }, props), {}, {
    className: (0, import_shared_utils4.cx)("chakra-alert__title", props.className),
    __css: styles.title
  }));
});

_AlertTitle.displayName = "AlertTitle"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Alert: _Alert,
  AlertDescription: _AlertDescription,
  AlertIcon: _AlertIcon,
  AlertTitle: _AlertTitle,
  useAlertStyles: _useAlertStyles
});